import { ReactElement } from 'react';
import { t } from '../../../common/getTranslations';
import { Layout } from '../../../design-system/layout/Layout';
import { Notice } from '../../../design-system/pages/Notice/Notice';
import { NoticeContainer } from '../../../domain/notice/container/NoticeContainer';
import { CommonMobileHeaderType } from '../../../header/constants';
function NoticePage() {
  return <NoticeContainer>
      {props => <div className="w-full bg-theme-bg-base pt-24pxr pb-35pxr text-theme-solid-100">
          <Notice {...props} />
        </div>}
    </NoticeContainer>;
}
NoticePage.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('more_notification')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.ThreeDepth
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: false
  }}>
      {page}
    </Layout>;
};
export default NoticePage;